import { HTTP, HTTP_WITHOUT_HEADER } from '../../utils'
import { getItem } from '../../storage'

export const populateProgramGuide = (cipCode, programGuideCode, type) => {
  let url = '/programguide/getByCipCode/' + cipCode + '?type=' + type
  if (programGuideCode) {
    url = url + '&code=' + programGuideCode
  }
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const populateProgramGuideCareers = (cipCode, code, showAllOccupations) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/majorMinor/program/' + cipCode + '/' + code + '/' + showAllOccupations)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const populateProgramCareerResult = (cipCode, programGuideCode, locationParam) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/majorMinor/emsi/' + cipCode + '/' + programGuideCode + '?levelAndGeoIds=' + locationParam)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getRelatedPrograms = (programId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('pathwaydata/program/' + programId + '/related')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getProgramCourseList = (streamId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('pathwaydata/stream/' + streamId + '/courses')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getProgramEducation = (streamId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('pathwaydata/stream/' + streamId + '/courses?type=EDUCATION')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getProgramCocurricular = (streamId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('pathwaydata/stream/' + streamId + '/courses?type=COCURRICULAR')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getMajorMinors = (page, count, name) => {
  if (!page || page < 0) {
    page = 0
  }
  let url = '/majorMinor/institutionList?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (name) {
    url = url + '&name=' + name
  }
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getMajorMinor = (code) => {
  let url = '/majorMinor/getByCode/' + code
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getLearnerExplorePrograms = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/programguide/learnerExplorePrograms')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getLearnerEnrolledProgram = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/programguide/learnerEnrolledProgram')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const saveEnrollmentStatus = (programCode, status) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/user/enroll/program/' + programCode + '/status/' + status)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const setProgramCourseStatus = (data) => {
  return getItem('token').then(token => {
    return HTTP(token).put('pathwaydata/catalog/' + data.uuid + '/status/' + data.status)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getAlumniInsightForProgram = (programCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/alumniinsight/program/' + programCode)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getTopAlumniCareersForProgram = (programCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/alumniinsight/program/' + programCode + '/top/careers')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getTopEmployersForAlumniCareer = (programCode, careerSoc) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/alumniinsight/program/' + programCode + '/career/' + careerSoc)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getTopAlumniCompaniesForProgram = (programCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/alumniinsight/program/' + programCode + '/top/companies')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getTopAlumniIndustriesForProgram = (programCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/alumniinsight/program/' + programCode + '/top/industries')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getTopAlumniJobTitlesForProgram = (programCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/alumniinsight/program/' + programCode + '/top/jobtitles')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const putCreatePaymentIntent = (transactionObj) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/transaction/createSalesIntent', transactionObj)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const putFinalizePaymentIntent = (transactionId) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/transaction/' + transactionId + '/finalizeSalesIntent')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getInstitutionPaymentPublicCredentials = (institutionId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/institution/publicCredentials/' + institutionId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getProgramGuideByCodeAndInstitutionId = (code, cipCode, type, institutionId) => {
  return HTTP_WITHOUT_HEADER().get('/programguide/getByCipCodeAndInstitutionId/' + cipCode + '?code=' + code + '&type=' + type + '&institutionId=' + institutionId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCheckValidityOfCoupon = (couponCode, programCode, pricingPlanId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/couponCode/' + couponCode + '/validity/' + programCode + '/' + pricingPlanId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCouponCode = (couponCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/couponCode/' + couponCode + '/findByCode')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getAllUserSISProgramMappings = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/sis/allUserSISMappings')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getUserSISProgramMapping = (sisProgramId, sisDegreeId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/sis/userSISMapping/' + sisProgramId + '/'+ sisDegreeId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const putCreateApplication = (sisProgramId, sisDegreeId) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/sis/createApplication/' + sisProgramId + '/'+ sisDegreeId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getResendApplicationLink = (sisProgramId, sisDegreeId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/sis/resendApplicationLink/' + sisProgramId + '/'+ sisDegreeId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getPaymentLink = (sisProgramId, sisDegreeId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/sis/paymentLink/' + sisProgramId + '/'+ sisDegreeId)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const putCreateSubscription = (transactionObj) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/transaction/createSubscription', transactionObj)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const deleteSubscription = (transactionObj) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/transaction/deleteSubscription', transactionObj)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/programguide/api.js